module.exports = __webpack_public_path__ + "img/mobile-hero-art.0fa7eb0b.svg";